import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import "./style/style.css";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Modal from "react-bootstrap/Modal";

import { getAttractionData } from "../../services/attractionsServices";
import { getLangIdFromCode } from "../../services/langUtils";

const textContent = {
  en: {
    MainAttractionsHeading: "Main Attractions",
    ReadMore: "Read More",
  },
  hi: {
    MainAttractionsHeading: "मुख्य आकर्षण",
    ReadMore: "और पढ़ें",
  },
};

const Block = ({ blockLabel, exhibits, onExhibitClick }) => (
  <div className={`item ${blockLabel.toLowerCase().replace(/\s/g, "-")}`}>
    <div className="block-label">{blockLabel}</div>
    <div className="items-row">
      {exhibits.map((exhibit, index) => (
        <div className="exhibits-item" key={index}>
          <span className="frame-border">
            <img src="/images/block-card-border.png" alt="" />
          </span>
          <div className="exhibits-inner">
            <div className="exhibits-image">
              <img src={exhibit.image} alt={exhibit.title} />
            </div>
            <div className="exhibits-info">
              <h4>{exhibit.title}</h4>
              <p>{exhibit.description}</p>
              <div
                onClick={() => onExhibitClick(exhibit)}
                className="custom-globle-button"
              >
                {exhibit.readMoreLabel}{" "}
                <span>
                  <img
                    alt="MuseumExhibits-2"
                    src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCA0MiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuODQ4Mjg1IDhMNDAuNjE2MSA4TTQwLjYxNjEgOEwzMS41MjYzIDFNNDAuNjE2MSA4TDMxLjUyNjMgMTUiIHN0cm9rZT0iIzNBM0EzQSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

const MuseumExhibits = ({ language }) => {
  const [show, setShow] = useState(false);
  const [selectedExhibit, setSelectedExhibit] = useState(null);

  const handleClose = () => setShow(false);
  const handleExhibitClick = (exhibit) => {
    setSelectedExhibit(exhibit);
    setShow(true);
  };

  const exhibitsOptions = {
    loop: false,
    margin: 60,
    nav: true,
    dots: false,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 },
    },
  };

  const langId = getLangIdFromCode(language);

  const {
    data: blocksData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["museumExhibits", langId],
    queryFn: ({ signal }) =>
      getAttractionData({ langId, mainOnly: true }, signal),
  });

  if (isLoading) return null;
  if (isError) {
    console.error(error);
    return null;
  }

  const blocksApi = blocksData || [];

  const blocks = blocksApi.map((block) => ({
    blockLabel: block.name || block.block_name,
    exhibits: (block.attractions || [])
      .slice()
      .sort((a, b) => (a.priority || 0) - (b.priority || 0))
      .map((attr) => ({
        title: attr.title,
        description: attr.short_desc || attr.body,
        image: attr.image,
        readMoreLabel: textContent[language].ReadMore,
      })),
  }));

  if (!blocks.length) return null;

  return (
    <>
      <div
        className="Museum-Exhibits"
        style={{ backgroundImage: "url(/images/gradient-bg.svg)" }}
      >
        <div className="section-heading">
          <h2>{textContent[language].MainAttractionsHeading}</h2>
        </div>

        <div className="container with-custom-arrow">
          <OwlCarousel
            className="owl-theme"
            {...exhibitsOptions}
            key={language}
          >
            {blocks.map((block, index) => (
              <Block
                key={index}
                blockLabel={block.blockLabel}
                exhibits={block.exhibits}
                onExhibitClick={handleExhibitClick}
              />
            ))}
          </OwlCarousel>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        className="main_attraction_modal_detail"
      >
        {selectedExhibit && (
          <>
            <Modal.Header closeButton>
              <Modal.Title>
                {textContent[language].MainAttractionsHeading}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="exhibits-image">
                <img src={selectedExhibit.image} alt={selectedExhibit.title} />
              </div>
              <div className="exhibits-info">
                <h4 className="exhibits-heading">{selectedExhibit.title}</h4>
                <p className="exhibits_content">
                  {selectedExhibit.description}
                </p>
              </div>
            </Modal.Body>
          </>
        )}
      </Modal>
    </>
  );
};

export default MuseumExhibits;
